import { Followers, Globe } from '@sparemin/blockhead';
import React from 'react';
import { BlueskyReplyLevel } from 'redux/middleware/api/podcast-service';
import { BlueskyReplyLevelSelectorOption } from './types';

export const getOptions = (): BlueskyReplyLevelSelectorOption[] => [
  {
    label: 'Anyone can reply to this post',
    logo: <Globe width="22px" height="22px" />,
    value: 'everybody',
  },
  {
    label: 'No one can reply to this post',
    logo: <Followers width="22px" height="22px" />,
    value: 'nobody',
  },
];

export function getReplyLevelOption(
  value: BlueskyReplyLevel,
): BlueskyReplyLevelSelectorOption {
  return getOptions().find(opt => opt.value === value);
}
